import { render, staticRenderFns } from "./RootCauseIndex.vue?vue&type=template&id=15c1a28f&scoped=true&"
import script from "./RootCauseIndex.vue?vue&type=script&lang=js&"
export * from "./RootCauseIndex.vue?vue&type=script&lang=js&"
import style0 from "./RootCauseIndex.vue?vue&type=style&index=0&id=15c1a28f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1a28f",
  null
  
)

export default component.exports